<div class="content">
  @for (unit of allUnits(); track unit) { @for (device of unit.devices;
  track device) {
  <div class="checkbox">
    <p>{{ device.name }}</p>
    <mat-checkbox
      [checked]="this.filter().devicesId?.includes(device.id!)"
      (click)="handlerDevice(device)"
    ></mat-checkbox>
  </div>
  }@empty {
  <p class="empyt">Nenhum dispositivo disponível</p>
  } }
</div>